import React from "react";

export default function EmtyCpsNotice(props) {
  return !props.disableEmptyCpsNotice && props.emptyCps ? (
    <div
      className="stat-cards__notice stat-cards__notice--blue stat-cards__notice--mb"
      style={{ lineHeight: 1.5 }}
    >
      Our records indicate the selected entity does not have any active contract pharmacy
      arrangements. Please reach out to support@340besp.com for further assistance on this.
    </div>
  ) : null;
}
